import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

export interface DateRangeItem {
    begindate: Date | string;
    enddate: Date | string;
}

@Pipe({
    name: 'dateRange',
    standalone: false,
})
export class DateRangePipe implements PipeTransform {
    transform(
        value: DateRangeItem,
        dateFormat: string = 'EEE d MMM yyyy HH:mm',
        dateFormatEndSameDay: string = 'HH:mm',
        dateFormatEndNextDay: string = 'EEE HH:mm',
        dateFormatEndOther: string = 'EEE d MMM yyyy HH:mm'
    ): string {
        if (!value?.begindate) {
            return '';
        }

        const datePipe = new DatePipe('nl');
        const begin = new Date(value.begindate);
        const end = value.enddate ? new Date(value.enddate) : null;

        const beginStr = datePipe.transform(begin, dateFormat);

        if (!end) {
            return beginStr;
        }

        const sameDay =
            begin.getFullYear() === end.getFullYear() &&
            begin.getMonth() === end.getMonth() &&
            begin.getDate() === end.getDate();

        const nextDay =
            !sameDay &&
            begin.getFullYear() === end.getFullYear() &&
            begin.getMonth() === end.getMonth() &&
            end.getDate() === begin.getDate() + 1;

        let endFormat: string;
        if (sameDay) {
            endFormat = dateFormatEndSameDay;
        } else if (nextDay) {
            endFormat = dateFormatEndNextDay;
        } else {
            endFormat = dateFormatEndOther;
        }

        const endStr = datePipe.transform(end, endFormat);
        return `${beginStr} - ${endStr}`;
    }
}
